import axios from "axios";

const axiosInstanceNoAuth = axios.create({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL,
});

axiosInstanceNoAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_data");
      // Only redirect if we're not already on the login page
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstanceNoAuth;
